import React from "react";
import { Offcanvas } from "react-bootstrap";
import { useTranslation } from "react-multi-lang";
import { useSelector } from "react-redux";
import { display } from "../Utility/Utility";
import StatusBadge from "./StatusBadge";

const ViewTransactionModal = ({ payin, onHide }) => {

  const t = useTranslation("transactions.view")
  const profile = useSelector((state) => state.admin.profile);

  const {
    order_id,
    utr_number,
    status_formatted,
    total_formatted,
    amount_formatted,
    commission_amount_formatted,
    created_at,
    updated_at
  } = payin || {};

  const {
    opening_balance,
    closing_balance
  } = payin?.ledger || {};

  const {
    status_code,
    sent_at
  } = payin?.callback || {};

  const showLedger = (profile?.data?.show_payin_ledger && ((status_formatted || "").toUpperCase() === "SUCCESS"));

  return (
    <Offcanvas show={!!payin} onHide={onHide} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{t("title")}</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <div className="view-modal-wrap">
          <div className="view-modal-card-wrap">
            <div className="view-modal-card">
              <div>{t("order_id")}</div>
              <div>{display(order_id)}</div>
            </div>
            <div className="view-modal-card">
              <div>{t("utr_number")}</div>
              <div>{display(utr_number)}</div>
            </div>
            <div className="view-modal-card">
              <div>{t("requested_amount")}</div>
              <div>{display(total_formatted)}</div>
            </div>
            <div className="view-modal-card">
              <div>{t("settlement_amount")}</div>
              <div> {display(amount_formatted)}</div>
            </div>
            <div className="view-modal-card">
              <div>{t("service_fee")}</div>
              <div> {display(commission_amount_formatted)}</div>
            </div>
          </div>
          {showLedger === true && (
            <>
              <div className="view-modal-card-wrap">
                <div className="view-modal-card">
                  <div>{t("opening_balance")}</div>
                  <div>{display(opening_balance)}</div>
                </div>
                <div className="view-modal-card">
                  <div>{t("closing_balance")}</div>
                  <div>{display(closing_balance)}</div>
                </div>
              </div>
            </>
          )}
          <div className="view-modal-card-wrap">
            <div className="view-modal-card">
              <div>{t("callback_status_code")}</div>
              <div>{display(status_code)}</div>
            </div>
            <div className="view-modal-card">
              <div>{t("callback_sent_at")}</div>
              <div>{sent_at ? (`${sent_at} UTC`) : '-'}</div>
            </div>
          </div>
          <div className="view-modal-card">
            <div>{t("status")}</div>
            <StatusBadge status={status_formatted} />
          </div>
          <div className="view-modal-card">
            <div>{t("created_date")}</div>
            <div>{display(created_at)}</div>
          </div>
          <div className="view-modal-card">
            <div>{t("updated_date")}</div>
            <div>{display(updated_at)}</div>
          </div>
        </div>
      </Offcanvas.Body>
    </Offcanvas >
  );
};

export default ViewTransactionModal;
